import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InputComponent),
    multi: true
  }]
})
export class InputComponent implements ControlValueAccessor {
  /**
   *
   * @InputComponent the use of this component allows the use of an icon or not.
   *  To do this, just pass parameters to the iconPathAlt
   *
   */

  @Input() public id: string;
  @Input() public label: string;
  @Input() public messageError: string;
  @Input() public error: boolean;
  @Input() public placeholder: string;
  @Input() public maxlength ?= null;
  @Input() public minlength ?= null;
  @Input() public maskInput ?= false;
  @Input() public suffixInput ?= false;
  @Input() public isPrice ?= false;
  @Input() public separator ?= '';
  @Input() public type = 'text';
  @Input() public iconPathAlt = {
    alt: null,
    path: '',
    rightPosition: false
  };
  @Input() public countNumber = null;
  @Input() public loading: boolean = false;
  @Input() public isDisabled: boolean = false;
  @Input() public toFixed: number;

  public dataValue = '';

  get value(): string {
    return this.toFixed ? Number(this.dataValue).toFixed(this.toFixed) : this.dataValue;
  }

  set value(data: string) {
    if (this.dataValue !== data) {
      this.dataValue = data;
      this.onChangeCb(data);
    }
  }


  public changeValue(e) {
    if (e.target.value && this.isPrice) {
      let price = e.target.value.replace(/\D/g, '');
      price = (+price / 100).toFixed(2) + '';
      price = price.replace('.', ',');
      price = price.replace(/(\d)(\d{3})(\d{3})(\d{3}),/g, '$1.$2.$3.$4,');
      price = price.replace(/(\d)(\d{3})(\d{3}),/g, '$1.$2.$3,');
      price = price.replace(/(\d)(\d{3}),/g, '$1.$2,');
      this.dataValue = price;
      this.onChangeCb(price);
    }
  }

  onChangeCb: (_: string) => void = () => {};
  onTouchedCb: (_: string) => void = () => {};

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: (_: string) => void): void {
    this.onChangeCb = fn;
  }

  registerOnTouched(fn: (_: string) => void): void {
    this.onTouchedCb = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

}
